var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { erc20Abi, getAddress } from 'viem';
import { getEVMRpcClient } from '../../quoting-engine/network/utils/getRpcClient';
import { isNativeToken } from '../../quoting-engine/network/utils/isNativeToken';
import { SupportedNetworks } from '../../config/networkAddresses';
import { CURRENT_VERSION } from '../../config/environment';
/**
 * Fetches the token balances for a given owner on a specified network.
 * @param network - The network on which the tokens exist.
 * @param tokens - The array of token addresses.
 * @param owner - The owner's address.
 * @returns An array of objects each containing the token address, raw balance, balance, and error message (if any).
 */
export function fetchEVMTokenBalances(_a) {
    return __awaiter(this, arguments, Promise, function (_b) {
        var client, results, nativeTokenPromises, erc20Tokens, erc20Calls, erc20Promise, allPromises, _c, nativeResults, erc20Results;
        var network = _b.network, tokens = _b.tokens, owner = _b.owner;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    client = getEVMRpcClient({ chainId: network });
                    results = [];
                    nativeTokenPromises = [];
                    erc20Tokens = [];
                    erc20Calls = [];
                    tokens.forEach(function (token) {
                        var error = '';
                        try {
                            getAddress(token);
                        }
                        catch (e) {
                            error = "Token address is invalid";
                            results.push({
                                network: network,
                                token: token,
                                rawBalance: BigInt(0),
                                balance: 0,
                                error: error,
                            });
                            return;
                        }
                        try {
                            getAddress(owner);
                        }
                        catch (e) {
                            error = "Owner address is invalid";
                            results.push({
                                network: network,
                                token: token,
                                rawBalance: BigInt(0),
                                balance: 0,
                                error: error,
                            });
                            return;
                        }
                        if (isNativeToken(token)) {
                            var decimals_1 = SupportedNetworks(CURRENT_VERSION)[network].decimals;
                            var nativePromise = client
                                .getBalance({ address: owner })
                                .then(function (nativeBalance) {
                                var rawBalance = BigInt(nativeBalance);
                                var balance = rawBalance > BigInt(0) ? Number(rawBalance) / Math.pow(10, decimals_1) : 0;
                                return { network: network, token: token, rawBalance: rawBalance, balance: balance, error: '' };
                            })
                                .catch(function (e) {
                                return {
                                    network: network,
                                    token: token,
                                    rawBalance: BigInt(0),
                                    balance: 0,
                                    error: "Error fetching native token balance: ".concat(e.message),
                                };
                            });
                            nativeTokenPromises.push(nativePromise);
                        }
                        else {
                            erc20Tokens.push(token);
                            erc20Calls.push({
                                abi: erc20Abi,
                                address: token,
                                functionName: 'balanceOf',
                                args: [owner],
                            }, {
                                abi: erc20Abi,
                                address: token,
                                functionName: 'decimals',
                                args: [],
                            });
                        }
                    });
                    erc20Promise = erc20Calls.length > 0
                        ? client
                            // @ts-ignore
                            .multicall({
                            contracts: erc20Calls,
                            allowFailure: false,
                        })
                            .then(function (response) {
                            var erc20Results = [];
                            for (var i = 0; i < erc20Tokens.length; i++) {
                                var rawBalance = response.shift();
                                var decimals = response.shift();
                                var balance = rawBalance > BigInt(0) ? Number(rawBalance) / Math.pow(10, decimals) : 0;
                                erc20Results.push({
                                    network: network,
                                    token: erc20Tokens[i],
                                    rawBalance: rawBalance,
                                    balance: balance,
                                    error: '',
                                });
                            }
                            return erc20Results;
                        })
                            .catch(function (e) {
                            return erc20Tokens.map(function (token) { return ({
                                network: network,
                                token: token,
                                rawBalance: BigInt(0),
                                balance: 0,
                                error: "Error fetching token balance: ".concat(e.message),
                            }); });
                        })
                        : Promise.resolve([]);
                    allPromises = Promise.all([Promise.all(nativeTokenPromises), erc20Promise]);
                    return [4 /*yield*/, allPromises];
                case 1:
                    _c = _d.sent(), nativeResults = _c[0], erc20Results = _c[1];
                    return [2 /*return*/, __spreadArray(__spreadArray(__spreadArray([], results, true), nativeResults, true), erc20Results, true)];
            }
        });
    });
}
